/** Revoke a linked channel (block 24). The backend answers `204` either way, so a retry is safe. */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
import { queryKeys } from "../query-keys.js";
export function useUnlinkChannel() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => getNookClient().unlinkChannel(id),
        retry: 1,
        onSettled() {
            void queryClient.invalidateQueries({ queryKey: queryKeys.channels.all() });
        },
    });
}
//# sourceMappingURL=use-unlink-channel.js.map